import React from 'react';
import { BasicQueryCheckboxTemplate } from 'themes/components';

function BasicQueryCheckbox(props) {
    return <BasicQueryCheckboxTemplate {...props} />
}

export default BasicQueryCheckbox;